import { Injectable } from '@angular/core';
export class StringUtilityService {
/**
 * @param {?} str
 * @return {?}
 */
isEmpty(str: string) {
    return str === '';
  }
/**
 * @param {?} text
 * @return {?}
 */
cleanText(text: string) {
    return text.replace(/ /g, '');
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function StringUtilityService_tsickle_Closure_declarations() {
/** @type {?} */
StringUtilityService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StringUtilityService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
